/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

require('../plugins');

window.Vue = require('vue');


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

// Vue.component("carousel", require('vue-owl-carousel2'));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */



$(document).ready(function () {
    $('.custom-file-input').on('change',function(){
        //get the file name
        var fileName = $(this).val();
        //replace the "Choose a file" label
        $(this).next('.custom-file-label').html(fileName);
    });

    $('.search-popup').modal();

    $('.l-search-form').on('click', '.l-search-form__overlay, .l-search-form__close', function(){
        $(this).closest('.l-search-form').fadeOut().removeClass('is-open');
        $('body').removeClass('modal-open');
    });

    $('.search-btn').on('click', function(e){
        e.preventDefault();
        $('.l-search-form').fadeIn().addClass('is-open');
        $('body').addClass('modal-open');
    });

    $('.contact-us-btn').click(function (e) {
        e.preventDefault();
        $('#contact-popup').modal();
    });

    $(".l-product__slider-img").zoom();

});
